/**
 * Hosted brand assets — the single place the shell and sidebar read them from, so a CDN
 * move is a one-line change instead of a hunt through components. (`src/environments/*.ts`
 * are local overrides that are never committed, so they cannot carry a shipped default.)
 */
/** Public TeamLease RegTech legal pages linked from the page footer. */
export const FOOTER_PRIVACY_POLICY_URL = 'https://www.teamleaseregtech.com/privacypolicy/';
export const FOOTER_TERMS_OF_USE_URL = 'https://www.teamleaseregtech.com/mobiletermsofuse/';

const BRAND_CDN_BASE = 'https://cdn.teamleaseregtech.com/regtrack/assets';

/** Default RegTrack logo (expanded sidebar) — the asset the compliance app falls back to. */
export const DEFAULT_SIDEBAR_LOGO_URL = `${BRAND_CDN_BASE}/vectors/RegtrackComplianceLogo.svg`;

/** RegTrack wordmark for the footer's "Powered by" line. */
export const FOOTER_REGTRACK_LOGO_URL =
  `${BRAND_CDN_BASE}/Images/reginsights-basic-email-template/regtrack-logo-with-tm.png`;
